import axios from 'axios';
import { cloneDeep } from 'lodash';
import * as types from '../actionTypes';
import * as urls from '../urlTypes';
import { saveTargetsList, getDefinitionSampleWt } from './deImportDefActions';
import { divideJointExpressions } from '../../util/autocodeUtils';
import { _setTargetNode,
  _validateEditTarget,
  _getFormattedTargetList,
  _getUpdatedListForBuild,
  _checkDuplicateTarget } from '../../util/deUtils';
import { getStudyFromStudies, fetchWeightTypeObj } from '../../util/CommonUtils';
import { updateWeightType } from '../studyActions'


export const setAddTargetFlag = flag => ({
  type: types.SET_ADD_TARGET_API_FLAG,
  flag,
});

export const addTargetsThunk = ({
  payload,
  expression,
  study,
  tn,
  selectedWeightType,
  autocodenode,
  uniqueId,
}) => ({
  type: types.ADD_DE_AUTOCODE_TARGETS,
  payload,
  expression,
  study,
  tn,
  selectedWeightType,
  autocodenode,
  uniqueId,
})

export const setIsEditTarget = isEditTarget => async (dispatch) => {
  dispatch({
  type: types.DE_BUILD_SET_IS_EDIT_TARGET,
  isEditTarget
  })
}
  

export const setIsSaveTargetClicked = (isClicked) => async (dispatch) => {
  dispatch({
    type: types.DE_BUILD_SET_IS_SAVE_TARGET_CLICKED,
    isClicked
  })
}

export const updateErrorSelectionBox = (payload) => async (dispatch) => {
  dispatch({
    type: types.DE_BUILD_UPDATE_ERROR_SELECTION_BOX,
    payload
  })
}

export const addTargets = (sampleWeightedParams, study, selectedWeightType, tn, autocodenode, uniqueId) => async (
  dispatch,
  getState
) => {
  const state = getState();
  const accountId = state.account.activeAccountId;
  const payload = await getDefinitionSampleWt(sampleWeightedParams);
  const targetArr =  _setTargetNode(
    payload,
    sampleWeightedParams.expressionList,
    study,
    tn,
    selectedWeightType,
    autocodenode,
    uniqueId)
  const validateTarget = await saveTargetsList(accountId, targetArr, true);
  dispatch(setAddTargetFlag(false));
  const failedTargetList = validateTarget.filter(item => item.success === 0);
  if(failedTargetList.length > 0){
    dispatch(updateErrorSelectionBox(true));
    return false
  }
  dispatch(addTargetsThunk({
    payload,
    expression: sampleWeightedParams.expressionList,
    study,
    tn,
    selectedWeightType,
    autocodenode,
    uniqueId,
  }),)
  return true
};

export const saveAutocodeTargetList = (accountId, isValidate, deBuildTargets) => async(dispatch, getState) =>{
  const state = getState()
  if (state.deBuild.isEditTarget){
    dispatch(setIsSaveTargetClicked(true))
    return false
  }
  const tempTargetList = cloneDeep(deBuildTargets);
  const targetList = _getFormattedTargetList(_getUpdatedListForBuild(tempTargetList), state.deBuild.partsToShow, true)
  const savedTargetList = await saveTargetsList(accountId, targetList, isValidate);
  if(savedTargetList){
    const notSentToSaveTargets = deBuildTargets.filter(item => item.isFailed || item.isDuplicate);
    dispatch({
      type: types.SAVE_DE_AUTOCODE_TARGET,
      payload: savedTargetList,
      deBuildTargets,
      notSentToSaveTargets
    });
  }
  return true
};

export const removeTargets = () => (dispatch) => {
  dispatch({
    type: types.REMOVE_DE_AUTOCODE_TARGETS
  });
};

export const removeTargetRow = index => (dispatch, getState) => {
  const state = getState();
  const deBuildTargets = cloneDeep([...state.deBuild.deBuildTargets])
  const duplicateList = deBuildTargets.filter(item =>
    item.ui.toLowerCase() === deBuildTargets[index].ui.toLowerCase() && !item.isFailed);
  if( duplicateList.length === 2){
    const duplicateId = duplicateList[0].ui
    deBuildTargets.map(item => {
      if(item.ui === duplicateId){
        item.isDuplicate = false;
      }
      return item;
    });
  }
  deBuildTargets.splice(index, 1);
  dispatch({
    type: types.REMOVE_DE_AUTOCODE_TARGET_ROW,
    deBuildTargets,
  });
};

export const setLabelTypeAC = (labelConfig) => ({
  type: types.DE_SET_SELECTED_LABEL_AC,
  labelConfig,
});

export const updateExpressionName = (name, index, targetArr, isDuplicate = false, isCancel = false) =>
    async(dispatch, getState) => {
  const state = getState();
  const accountId = state.account.activeAccountId;
  let failedTargetList = []
  if(!isCancel){
    const validateTarget = await saveTargetsList(accountId, targetArr, true);
    failedTargetList = validateTarget.filter(item => item.success === 0);
  }
  if(failedTargetList.length > 0){
    isDuplicate = false
  }
  dispatch({
    type: types.DE_BUILD_UPDATE_EXPRESSION_NAME,
    name,
    index,
    isFailed: failedTargetList.length > 0,
    isDuplicate,
    isCancel
  })
  dispatch(setIsEditTarget(false))
  if(getState().deBuild.isSaveTargetClicked){
    await dispatch(setIsSaveTargetClicked(false))
    dispatch(saveAutocodeTargetList(accountId,false, getState().deBuild.deBuildTargets));
  }
  dispatch(setIsSaveTargetClicked(false))
  return !failedTargetList.length
};

export const updateSelectionBoxFlag = (flag) => ({
  type: types.DE_BUILD_UPDATE_UNSAVED_CHANGES,
  flag
})

export const isDataContains = () => (dispatch, getState) => {
  const unsavedSelectionBox = getState().deBuild.unsavedSelectionBox;
  const deBuildTargets = getState().deBuild.deBuildTargets
  const tempTarget = getState().deBuild.tempTarget
  const editTarget = getState().deBuild.editTarget
  if( deBuildTargets.length > 0 ){
    return true
  }
  if( tempTarget !== null ){
    if( editTarget !== null && _validateEditTarget(editTarget, tempTarget) ){
      return true
    }
    if( editTarget === null){
      return true
    }
  }
  return (tempTarget === null && unsavedSelectionBox)
}

export const fetchDictionaryDetails = async (uid, accountId, target) => {
  const url = `${urls.ROOT_URL}/dictionary/detail/${uid}/${accountId}/${target.pn}`;
  const expressionList = divideJointExpressions([target.expr]);

  try {
    const response = await axios({
      url,
      method: 'post',
      responseType: 'json',
      data: expressionList,
      withCredentials: true,
    });
    const responseType = typeof response.data;
    if (response.data && responseType === 'object') {
      return response.data.data;
    }
    return false;
  } catch (error) {
    console.warn("Dictionary details Couldn't be fetched => ", error)
    return false;
  }
};

export const setTempSelectedTargetForBuild = target => ({
  type: types.SET_DE_AUTOCODE_TEMP_TARGET_EDIT,
  target
})

export const setEditTargetDataForBuild = target => (dispatch, getState) => {
  const state = getState();
  const studies = state.deImportDefiniton.studies.data;
  const study = getStudyFromStudies(studies, target.pn)

  const selectedStudy = getStudyFromStudies(studies, target.pn);
  
  if(study) {
    dispatch(updateWeightType('Datahub', fetchWeightTypeObj(selectedStudy.cw, target.wt)));
    dispatch({
      type: types.SET_DE_ACTIVE_STUDY,
      activeStudy: selectedStudy
    })
    dispatch(setTempSelectedTargetForBuild(target))
  }
}

export const setEditTargetNode = (target) => (dispatch) => {
  dispatch({
    type: types.SET_DE_BUILD_EDIT_TARGET,
    target
  })
}

export const setDupicateTargetNode = (targetNode) => async(dispatch, getState) => {
  const state = getState();
  const accountId = state.account.activeAccountId;
  const targetArr = [];
  const target = cloneDeep(targetNode);
  let failedTargetList = [];
  if(target.originalTitle === ''){
    target.originalTitle = target.tn
  }
  target.tn = `Copy_${target.originalTitle}`;
  targetArr.push(target);
  const validateTarget = await saveTargetsList(accountId, targetArr, true);
  failedTargetList = validateTarget.filter(item => item.success === 0);
  const duplicateTarget = _checkDuplicateTarget(state.deBuild.deBuildTargets, target)
  target.originalTitle = `Copy_${target.originalTitle}`;
  dispatch({
    type: types.DE_BUILD_DUPLICATE_TARGET,
    target,
    isFailed: failedTargetList.length > 0,
    isDuplicate: duplicateTarget.length > 0
  })
}